import React from "react"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"

import { AuthContextProvider } from "redux/contexts/auth"
import Routes from "routes"
import { store, persistor } from "redux/store"
import { setupAxiosInterceptors } from "redux/api"

import "config/i18n"

function App() {
  setupAxiosInterceptors(store)

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthContextProvider>{Routes}</AuthContextProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
